import { createSelector } from 'reselect';
import { RootState } from '../store';
import { TestParameters } from './types';

const loading = (state: RootState) => state.waterTestStrip.loading;
const error = (state: RootState) => state.waterTestStrip.error;
const success = (state: RootState) => state.waterTestStrip.success;
const selectWaterTestStripStatus = (state: RootState) => state.waterTestStrip.status;
const getData = (state: RootState) => state.waterTestStrip.data
const selectWaterTestStripResult = createSelector(
  [getData],
  (data) => data?.parameters as TestParameters
);


const makeWaterTestStripGroupedResults = createSelector(
  [
    getData,
  ],
  (data):{Good?: number, Low?:number, High?: number, NA?:number, Caution?: number} => {
    const {parameters} = data

    const entries = Object.entries(parameters)
    return entries.reduce((acc, curr)=> {
      const [_,v] = curr

      if(Array.isArray(v)) {v.forEach(item => {
        if(!acc[item.label]){return acc[item.label] =1}
        acc[item.label] += 1
      })}
      return acc
    }, {})

  }
)

export const WaterTestStripSelector = {
  selectWaterTestStripStatus,
  selectWaterTestStripResult,
  makeWaterTestStripGroupedResults,
  loading,
  error,
  success,
  getData,
};